import React from 'react';
import {AppBar, Grid, Tab, Tabs} from "@material-ui/core";
import {a11yProps, TabPanel} from "../../ClientProfile/component/TabsMenu";
import Viewer from "../../../../components/Viewer";
import {Proposal} from "../../../../model/proposal";
import {isDebug, sleep, va} from "../../../../utils/commonUtils";
import { CallingFromObject, ClientProposal, GWT_GEN2_STRATEGY } from "../../../../constants";
import ProposalSummary from "./ProposalSummary";
import StressProposalSummary from "./StressProposalSummary";
import { useGetRecipientPageProps } from "../../../../model/PageProps";
import {isNfIulCase} from '../../../../utils/commonFunc';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../reducers';


interface ProposalTabsProps {
    /**
     * active tab
     */
    activeProposalTab: number;
    /**
     * Runs when both tabs are cliecked
     */
    callBack: Function;
    /**
     * proposal file url and names
     */
    proposalObjArr: Proposal[];
    /**
     * tab change function
     */
    setActiveProposalTab: Function;
    /**
     * clientId to show summary Detail
     */
    clientPolicyId?: string;
    /**
     * CallingFromObject.GIFTOR_RECIPIENT it is need only in userId
     */
    userId?: string;
    /**
     * callingFrom
     */
    callingFrom?: string;


}


/**
 * renders admin_proposal document as tabs viewer for agent (view and approve) and client (approve and sign)
 * @param props
 * @constructor
 */
const ProposalTabs: React.FunctionComponent<ProposalTabsProps> = (props) => {
    const {
        activeProposalTab,
        callBack,
        proposalObjArr,
        setActiveProposalTab,
        clientPolicyId,
        userId,
        callingFrom
    } = props;
    const { user: { client } } = useSelector((state: RootState) => state.auth);
    const profile = useSelector((state: RootState) => state.profile);
    const clientPolicy: any = profile && profile.client && profile.client.clientPolicies && profile.client.clientPolicies[0];
    const strategySlug: string = clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug ? clientPolicy.strategy.slug : "";
    const isNfIul = isNfIulCase((clientPolicy && clientPolicy.strategy && clientPolicy.strategy.id) as number, strategySlug);
    const [clickCounter, setClickCounter] = React.useState(1);
    const [isLoading, setIsLoading] = React.useState(true);
    const [forceRefresh, setForceRefresh] = React.useState(0);
    const propsStrategyId = useGetRecipientPageProps("strategyId")
    const propsCarrierId = useGetRecipientPageProps("carrierId")
    const hasMultipleFiles = !!proposalObjArr.length;
    const sortedProposalArr = proposalObjArr.sort((a, b) => (a.name === ClientProposal ? -1 : b.name === ClientProposal ? 1 : 0));  // Client Proposal needs to appear first
    // Mapping Name For Admin Proposal
    let TabNameMapper = {
        "proposalSummary": "Proposal Summary",
        "Carrier Illustration": "Carrier Illustration",
    };
    if (!isNfIul) {
        TabNameMapper[ClientProposal] = "Kai-Zen Proposal"
    }

    /**
     * handler for tab change
     * @param _ev
     * @param newValue
     */
    const handleChange = async (_ev: React.ChangeEvent<{}>, newValue: number) => {
        // setting initial refresh
        setForceRefresh(0);

        // setting loading
        setIsLoading(true);

        // inducing server latency
        await sleep();

        // setting counter to show actions
        const counter = clickCounter + 1;
        setActiveProposalTab(newValue);
        setClickCounter(counter);

        // counter is 2, both document tabs viewed
        if (counter === 2) {
            callBack();
        }

        // setting refresh
        setForceRefresh(Math.random());
    };

    // has proposal docs, show first tab
    const initialRefresh = () => {
        if (proposalObjArr && proposalObjArr.length) {
            setForceRefresh(Math.random());
        }
    };
    isDebug() && console.log(activeProposalTab)
    React.useEffect(initialRefresh, [proposalObjArr]);
    return (
            <>
                <Grid item xs={12}>
                    <AppBar position="static" color="default">
                        <Tabs
                                value={activeProposalTab}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="on"
                                indicatorColor="primary"
                                textColor="primary"
                                aria-label="scrollable force tabs example"
                        >
                            {<Tab key={"proposalSummary"} value={0}
                                  label={TabNameMapper["proposalSummary"]} {...a11yProps("proposalSummary")} />}
                            {
                                hasMultipleFiles && va(sortedProposalArr) &&
                                    sortedProposalArr.filter((proposal: Proposal) => {
                                            // Remove the Kai-Zen tab when isNfIul is true
                                            if (isNfIul && proposal.name === ClientProposal) return false;
                                            return true;
                                        })
                                        .map((proposal: Proposal, index: number) => (
                                            <Tab key={index}
                                                label={TabNameMapper[proposal.name]} {...a11yProps(index)} />
                                        ))
                            }
                            
                        </Tabs>
                    </AppBar>
                </Grid>

                {
                        hasMultipleFiles && va(sortedProposalArr) &&
                        sortedProposalArr.filter((proposal: Proposal) => {
                                            if (isNfIul && proposal.name === ClientProposal) return false;
                                            return true;
                                        }).map((proposal: Proposal, index: number) => {
                            return (
                                    <Grid key={index+1} item xs={12}>
                                        <TabPanel index={index+1} value={activeProposalTab}>
                                            {
                                                // forcefully refresh for iframe viewer
                                                    forceRefresh !== 0 &&
                                                    <Viewer
                                                            force={setForceRefresh}
                                                            loading={isLoading}
                                                            setLoading={setIsLoading}
                                                            title={proposal.name}
                                                            url={proposal.url}
                                                    />
                                            }
                                        </TabPanel>
                                    </Grid>
                            )
                        })
                }
                <Grid key={"proposalSummary"} item xs={12}>
                    <TabPanel index={0} value={activeProposalTab}>
                        <>
                            {
                                    callingFrom === CallingFromObject.GIFTOR_RECIPIENT &&
                                    <StressProposalSummary
                                            callingFrom={CallingFromObject.GIFTOR_RECIPIENT}
                                            clientPolicyId={clientPolicyId as string}
                                            userId={userId as string}
                                            strategyId={propsStrategyId || GWT_GEN2_STRATEGY}
                                            // if carrierId will same as parent's carrierId. this component will use logged in user CarrierId
                                            carrierId={propsCarrierId}
                                    />
                            }
                                {
                                        callingFrom !== CallingFromObject.GIFTOR_RECIPIENT &&
                                        <ProposalSummary clientPolicyId={clientPolicyId}/>
                                }
                        </>
                    </TabPanel>
                </Grid>
            </>
    );
};

export default ProposalTabs;
